import { compose, withState, withHandlers } from "recompose";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { fetchApi } from "core/api/hoc";
import * as selectors from "modules/user/auth/selectors";
import * as api from "modules/user/auth/api";
import View from "./View";

export default compose(
  fetchApi(api.checkUserDiscount, {
    selector: selectors.checkUserDiscountApi,
    key: "discount",
    sync: true
  }),
  withState("showMenu", "setMenu", false),
  withHandlers({
    handleClick: props => event => {
      return props.setMenu(!props.showMenu);
    }
  }),
  connect(
    createStructuredSelector({
      user: selectors.fetchUserData,
      isAuthenticated: selectors.isAuthenticated
    })
  )
)(View);



// WEBPACK FOOTER //
// ./src/components/common/candidate/Overlay/Provider.js